import React from 'react'
import Lots from './Common/Lots'

const OpenItemsLots = () => <Lots apiEndpoint='/api/lots/open-items' />

export default OpenItemsLots
